import { Controller } from "@hotwired/stimulus"

// Documentation API, « Vos identifiants de template » : l'ID choisi dans le tableau remplit
// `parent_template_id` et `template_id` dans les exemples de payload de la même page (les
// emplacements `data-api-docs-template-slot`, posés par ApiDocs::TemplateVariable). Le choix n'est
// proposé que s'il y a plusieurs ID ; il est gardé par guide.
export default class extends Controller {
  static targets = ["choice"]
  static values = { storageKey: String, defaultId: String }

  connect() {
    this.restore()
    this.apply()
  }

  choose() {
    this.store()
    this.apply()
  }

  chooseRow(event) {
    if (event.target.closest("button, a, input, label")) return

    const radio = event.currentTarget.querySelector("input[type='radio']")
    if (!radio || radio.checked) return

    radio.checked = true
    this.choose()
  }

  apply() {
    const id = this.selectedId
    if (!id) return

    this.slots.forEach((slot) => { slot.textContent = id })
  }

  get selectedId() {
    const checked = this.choiceTargets.find((choice) => choice.checked)
    return checked?.value || this.defaultIdValue
  }

  get slots() {
    return (this.element.closest(".api-docs__page") || document).querySelectorAll("[data-api-docs-template-slot]")
  }

  // Un choix gardé n'est repris que s'il est encore proposé : les templates changent.
  restore() {
    if (!this.hasChoiceTarget) return

    try {
      const saved = localStorage.getItem(this.storageKeyValue)
      const match = this.choiceTargets.find((choice) => choice.value === saved)
      if (match) match.checked = true
    } catch { /* stockage indisponible : on garde l'ID de départ */ }
  }

  store() {
    if (!this.hasChoiceTarget) return

    try {
      localStorage.setItem(this.storageKeyValue, this.selectedId)
    } catch { /* idem */ }
  }
}
